import { connect } from 'react-redux';

import ChatArea from '../components/StartScreen/ChatArea';
// import { setMessages } from '../core/actions/MessagesAction';
//import { State } from '../core/reducers/index';
import { updateTypingUsers } from '../core/sideEffects';

const mapStateToProps = (state: any) => ({
  typingNotifications: state.chat.typingNotifications
});

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateTypingUsers: () => dispatch(updateTypingUsers()),
  sendMessage:(message:string) => {
    console.log(message,'saasaas');
  // dispatch(setMessages(message))
}
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatArea);
